import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    display: 'flex',
    height: '100%',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  button: {
    marginTop: theme.spacing(1),
  },
  title: {
    paddingBottom: theme.spacing(3),
  },
}));

const NotFoundComponent = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="h2" className={classes.title}>
        <FormattedMessage id="not_found.title" />
      </Typography>
      <Typography variant="body1">
        <FormattedMessage id="not_found.body" />
      </Typography>
    </div>
  );
};

export default NotFoundComponent;
